document.addEventListener('DOMContentLoaded', () => {
 
  const imageContainer = document.querySelector('.multicolumn-skin-type__item');
  const multicolumnCards = document.querySelectorAll('.multicolumn-card');

  if(imageContainer) {
    // For mobile devices
    imageContainer.addEventListener('click', (event) => {
        if (!imageContainer.classList.contains('touch-active')) {
            event.preventDefault(); // Prevent triggering a click immediately
            imageContainer.classList.add('touch-active');
            document.addEventListener('click', handleOutsideClick, { once: true });
        }
    });

    function handleOutsideClick(event) {
        if (!imageContainer.contains(event.target)) {
            imageContainer.classList.remove('touch-active');
        }
    }
  }

  // For mobile devices - handle content toggle with touch using class toggling
  if(multicolumnCards.length > 0) {
    multicolumnCards.forEach(card => {
      if (card.classList.contains('has-hover-content')) {
        card.addEventListener('click', function() {
          // Only handle click for mobile devices
          if (window.innerWidth <= 749) {
            this.classList.toggle('show-back');
          }
        });
      }
    });
  }
});
